'use client';

import { useThemeBootstrap } from '@up2promo-setup-frontend/core/hooks/use-theme-bootstrap';
import { DialogManager } from '@up2promo-setup-frontend/ui/providers/dialog-manager';
import LoadingOverlay from '@up2promo-setup-frontend/ui/components/loading-overlay';
import { MotionConfig } from 'motion/react';
import type { ReactNode } from 'react';

export default function Providers({ children }: { children: ReactNode }) {
  useThemeBootstrap();

  return (
    <MotionConfig reducedMotion="user">
      <DialogManager>
        <LoadingOverlay />
        <div className="flex min-h-dvh w-full flex-1 flex-col">{children}</div>
      </DialogManager>
    </MotionConfig>
  );
}
